import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-sub-header',
	templateUrl:'./WaPageSubHeaderProPage.html',
	styles: [],
	styleUrls:['./WaPageSubHeaderProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageSubHeaderProPage
{
	mdContent_415 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageSubHeader;
\`\`\``;
	mdContent_416 = `\`\`\`java
new WaPageSubHeader<>()
\`\`\``;
}
